import axios from "axios"

/**
 * Delete a DID record via API
 * @param {string} idToken - JWT token for authentication
 * @param {string} apiEndpoint - API endpoint URL
 * @param {string} did - Document ID to delete
 * @returns {Promise<Object>} - Promise resolving to API response
 */
const DeleteDocument = (idToken, apiEndpoint, did) => {
  // For DELETE requests, send the DID in the request body
  // We need to use axios with explicit body data
  const config = {
    method: 'DELETE',
    url: apiEndpoint,
    headers: {
      "Authorization": idToken,
      "Content-Type": "application/json"
    },
    data: JSON.stringify({
      did: did
    })
  }

  // Debug logging
  console.log('DELETE Request Config:', {
    url: apiEndpoint,
    headers: config.headers,
    data: config.data
  });

  return new Promise((resolve, reject) => {
    axios(config)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        // Debug logging
        console.error('DELETE Request Error:', {
          message: err.message,
          response: err.response?.data,
          status: err.response?.status,
          request: err.request
        });
        
        // Handle different error types
        if (err.response) {
          // Server responded with error status
          const status = err.response.status
          const message = err.response.data?.message || err.response.statusText

          if (status === 401) {
            reject(new Error('Authentication failed. Please log in again.'))
          } else if (status === 403) {
            reject(new Error('Permission denied. Librarian access required.'))
          } else if (status === 400) {
            reject(new Error(`Invalid request: ${message}`))
          } else if (status === 404) {
            reject(new Error('Document not found.'))
          } else {
            reject(new Error(`Server error: ${message}`))
          }
        } else if (err.request) {
          // Request made but no response received
          reject(new Error('Network error. Please check your connection and try again.'))
        } else {
          // Something else happened
          reject(new Error(`Delete failed: ${err.message}`))
        }
      })
  })
}

export default DeleteDocument
